import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PendingRequestService } from "../pendingrequest.service";

@Injectable()
export class PendingRequestsHttpInterceptor implements HttpInterceptor {
  private numberOfPendingRequests = 0;

  constructor(private pendingRequestsService: PendingRequestService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (req.headers.has("backgroundRequest")) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            this.pendingRequestsService.publishNumberOfPendingRequests$(
              --this.numberOfPendingRequests
            );
          } else {
            this.pendingRequestsService.publishNumberOfPendingRequests$(
              ++this.numberOfPendingRequests
            );
          }
        },
        error: () =>
          this.pendingRequestsService.publishNumberOfPendingRequests$(
            --this.numberOfPendingRequests
          ),
      })
    );
  }
}
